import i18n from '@/i18n'
import { ElMessage } from 'element-plus'
import copyMsg from 'copy-to-clipboard'

export const copy = (msg) => {
  copyMsg(msg)
    ? ElMessage.success(i18n.global.t('msg.common.copySuccessful'))
    : ElMessage.error('Copy failed')
}
